import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Multiselect from "multiselect-react-dropdown";
import React, { useState } from "react";
import "react-querybuilder/dist/query-builder.css";
import { toast } from "react-toastify";
import { UPDATE_CUSTOM_FILTER } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "../HomeHeader.css";

const AddCustomFilter = (props) => {
  const [newCustomTags, setNewCustomTags] = useState([]);
  const [errorfortags, seterrorfortags] = useState(false);

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "50%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  function onSelect(selectedList) {
    let customtags = selectedList.map((options) => options.name);
    setNewCustomTags(customtags);
  }
  function onRemove(selectedList) {
    let customtags = selectedList.map((options) => options.name);
    setNewCustomTags(customtags);
  }

  const handleselectedcustomdata = () => {
    if (newCustomTags.length == 0) {
      seterrorfortags(true);
      setTimeout(() => {
        seterrorfortags(false);
      }, 2000);
      return;
    }
    const SendData = async () => {
      let filterobj = newCustomTags;
      try {
        const response = await axiosInstance.post(
          `${UPDATE_CUSTOM_FILTER}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );

        if (response.data.success && response.data.success == true) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.handleBackButton();
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.handleBackButton();
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };
  return (
    <div>
      <Modal
        className="rounded d-flex justify-content-center align-items-center"
        onClose={props.handleClose}
        open={props.ModalState}
      >
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold  mt-2">Filter</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={props.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div className="mt-3">
            <div>
              {" "}
              <Multiselect
                options={props.totalFieldList}
                displayValue="label"
                onSelect={onSelect}
                onRemove={onRemove}
                placeholder="Custom Filter"
                style={{
                  chips: { background: "black", fontWeight: "normal" },
                  multiselectContainer: {
                    background: "#1A2C2B",
                    border: "1px solid #0f9077",
                    borderRadius: "5px",
                    outline: "none",
                  },
                  searchBox: {
                    border: "none",
                  },
                  inputField: {
                    // To change input field position or margin
                    color: "white",
                  },
                  option: {
                    background: "black",
                    color: "#FFFFFF",
                    fontWeight: "normal",
                  },
                }}
              />
              {newCustomTags && newCustomTags.length == 0 && errorfortags && (
                <span className="errorStyles">Custom Filter Required</span>
              )}
            </div>
            <div className="d-flex justify-content-between">
              <div>
                {" "}
                <button
                  className="btn-class"
                  onClick={() => {
                    handleselectedcustomdata();
                  }}
                >
                  Confirm
                </button>
              </div>
              <div>
                {" "}
                <button
                  className="btn-class"
                  onClick={() => {
                    props.handleBackButton();
                  }}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AddCustomFilter;
